export const TRANSLATION_KEYS = {
    alert: {
        heading: 'alert.heading',
        generic: 'alert.generic',
        expiredSession: 'alert.expiredSession',
        retry: 'alert.retry',
        noData: {
            heading: 'alert.noData.heading',
        },
    },
    banner: {
        opensNewTab: 'banner.opensNewTab',
    },
    common: {
        goBackAriaLabel: 'common.goBackAriaLabel',
        cancel: 'common.cancel',
        continue: 'common.continue',
    },
    dateFormat: {
        monthAbbreviations: {
            Jan: 'dateFormat.monthAbbreviations.Jan',
            Feb: 'dateFormat.monthAbbreviations.Feb',
            Mar: 'dateFormat.monthAbbreviations.Mar',
            Apr: 'dateFormat.monthAbbreviations.Apr',
            May: 'dateFormat.monthAbbreviations.May',
            Jun: 'dateFormat.monthAbbreviations.Jun',
            Jul: 'dateFormat.monthAbbreviations.Jul',
            Aug: 'dateFormat.monthAbbreviations.Aug',
            Sep: 'dateFormat.monthAbbreviations.Sep',
            Oct: 'dateFormat.monthAbbreviations.Oct',
            Nov: 'dateFormat.monthAbbreviations.Nov',
            Dec: 'dateFormat.monthAbbreviations.Dec',
        },
        weekFormat: 'dateFormat.weekFormat',
        dayFormat: 'dateFormat.dayFormat',
    },
    assetsProtection: {
        title: 'assetsProtection.title',
        filters: {
            viewInDollars: 'assetsProtection.filters.viewInDollars',
            viewInPercent: 'assetsProtection.filters.viewInPercent',
        },
        yearToDate: 'assetsProtection.yearToDate',
        tabs: {
            payroll: 'assetsProtection.tabs.payroll',
            theft: 'assetsProtection.tabs.theft',
            secure: 'assetsProtection.tabs.secure',
        },
        secure: {
            title: 'assetsProtection.secure.title',
            security: 'assetsProtection.secure.security',
            location: 'assetsProtection.secure.location',
            crimesAgainstProperty:
                'assetsProtection.secure.crimesAgainstProperty',
            crimesAgainstPeople: 'assetsProtection.secure.crimesAgainstPeople',
            disorderlyConducts: 'assetsProtection.secure.disorderlyConducts',
            securityResolution: 'assetsProtection.secure.securityResolution',
            'disorderly conducts':
                'assetsProtection.secure.disorderly conducts',
            'crimes against people':
                'assetsProtection.secure.crimes against people',
            'crimes against property':
                'assetsProtection.secure.crimes against property',
            ty: 'assetsProtection.secure.ty',
            'b/(p) to ly': 'assetsProtection.secure.b/(p) to ly',
        },
        payroll: {
            actual: 'assetsProtection.payroll.actual',
            plan: 'assetsProtection.payroll.plan',
            published: 'assetsProtection.payroll.published',
            'b/(p) to plan': 'assetsProtection.payroll.b/(p) to plan',
            'b/(p) to published': 'assetsProtection.payroll.b/(p) to published',
            payrollBPLYLabel: 'assetsProtection.payroll.payrollBPLYLabel',
            apl: 'assetsProtection.payroll.apl',
            aps: 'assetsProtection.payroll.aps',
            tps: 'assetsProtection.payroll.tps',
        },
        theft: {
            'merchandise investigations':
                'assetsProtection.theft.merchandise investigations',
            'POS/other investigations':
                'assetsProtection.theft.POS/other investigations',
            'detained apprehensions':
                'assetsProtection.theft.detained apprehensions',
            'external app productivity':
                'assetsProtection.theft.external app productivity',
            'average app $': 'assetsProtection.theft.average app $',
            'NPI rate': 'assetsProtection.theft.NPI rate',
            PMR: 'assetsProtection.theft.PMR',
            KTR: 'assetsProtection.theft.KTR',
            ty: 'assetsProtection.theft.ty',
            'b/(p) to ly': 'assetsProtection.theft.b/(p) to ly',
            'days to close (avg)': 'assetsProtection.theft.days to close (avg)',
            internal: 'assetsProtection.theft.internal',
            external: 'assetsProtection.theft.external',
        },
        internal: 'assetsProtection.internal',
        external: 'assetsProtection.external',
        priorWeek: 'assetsProtection.priorWeek',
        priorMonth: 'assetsProtection.priorMonth',
        headers: {
            internal: {
                loc: 'assetsProtection.headers.internal.loc',
                merchCases: 'assetsProtection.headers.internal.merchCases',
                merchCasesBPLY:
                    'assetsProtection.headers.internal.merchCasesBPLY',
                posOtherCases:
                    'assetsProtection.headers.internal.posOtherCases',
                posOtherCasesBPLY:
                    'assetsProtection.headers.internal.posOtherCasesBPLY',
                daysToClose: 'assetsProtection.headers.internal.daysToClose',
            },
            external: {
                loc: 'assetsProtection.headers.external.loc',
                detainedApps: 'assetsProtection.headers.external.detainedApps',
                KTRToAppPercent:
                    'assetsProtection.headers.external.KTRToAppPercent',
                externalAppProductivity:
                    'assetsProtection.headers.external.externalAppProductivity',
                averageAppDollars:
                    'assetsProtection.headers.external.averageAppDollars',
                npiRate: 'assetsProtection.headers.external.npiRate',
            },
            payrollRGDMonthly: {
                Store: 'assetsProtection.headers.payrollRGDMonthly.Store',
                Region: 'assetsProtection.headers.payrollRGDMonthly.Region',
                Group: 'assetsProtection.headers.payrollRGDMonthly.Group',
                District: 'assetsProtection.headers.payrollRGDMonthly.District',
                'Actual Hrs':
                    'assetsProtection.headers.payrollRGDMonthly.Actual Hrs',
                'Plan Hrs':
                    'assetsProtection.headers.payrollRGDMonthly.Plan Hrs',
                'Published Hrs':
                    'assetsProtection.headers.payrollRGDMonthly.Published Hrs',
                'b/(p) to Plan':
                    'assetsProtection.headers.payrollRGDMonthly.b/(p) to Plan',
                'b/(p) % to Plan':
                    'assetsProtection.headers.payrollRGDMonthly.b/(p) % to Plan',
                'b/(p) % to Published':
                    'assetsProtection.headers.payrollRGDMonthly.b/(p) % to Published',
            },
        },
    },
    indexRedirectMessage: 'indexRedirectMessage',
    layout: {
        appTitle: 'layout.appTitle',
        greenfieldLinkTitle: 'layout.greenfieldLinkTitle',
        logOutCTA: 'layout.logOutCTA',
        navMenuAriaLabel: 'layout.navMenuAriaLabel',
        navMenuCloseAriaLabel: 'layout.navMenuCloseAriaLabel',
        searchAriaLabel: 'layout.searchAriaLabel',
    },
    locationSearch: {
        header: 'locationSearch.header',
        searchLabel: 'locationSearch.searchLabel',
        matchNotFound: 'locationSearch.matchNotFound',
        nearbyLocationsHeader: 'locationSearch.nearbyLocationsHeader',
        clearSearchAriaLabel: 'locationSearch.clearSearchAriaLabel',
    },
    loyalty: {
        title: 'loyalty.title',
        tabs: {
            overview: 'loyalty.tabs.overview',
            targetCircle: 'loyalty.tabs.targetCircle',
            targetCircleCard: 'loyalty.tabs.targetCircleCard',
            targetCircle360: 'loyalty.tabs.targetCircle360',
        },
        timePeriods: {
            currentWeek: 'loyalty.timePeriods.currentWeek',
            lastWeek: 'loyalty.timePeriods.lastWeek',
            monthToDay: 'loyalty.timePeriods.monthToDay',
            yearToDay: 'loyalty.timePeriods.yearToDay',
        },
        overview: {
            currentWeek: 'loyalty.overview.currentWeek',
            lastWeek: 'loyalty.overview.lastWeek',
            percentTranslationsTargetCircle:
                'loyalty.overview.percentTranslationsTargetCircle',
            percentTranslationsTargetCircleCard:
                'loyalty.overview.percentTranslationsTargetCircleCard',
            Sun: 'loyalty.overview.Sun',
            Mon: 'loyalty.overview.Mon',
            Tue: 'loyalty.overview.Tue',
            Wed: 'loyalty.overview.Wed',
            Thu: 'loyalty.overview.Thu',
            Fri: 'loyalty.overview.Fri',
            Sat: 'loyalty.overview.Sat',
            location: 'loyalty.overview.location',
            targetCircle: 'loyalty.overview.targetCircle',
            targetCircleCardHeading: 'loyalty.overview.targetCircleCardHeading',
            total: 'loyalty.overview.total',
            targetCircleCard: 'loyalty.overview.targetCircleCard',
        },
        circleCard: {
            applications: 'loyalty.circleCard.applications',
            applicationNumbers: 'loyalty.circleCard.applicationNumbers',
            summary: 'loyalty.circleCard.summary',
            location: 'loyalty.circleCard.location',
            total: 'loyalty.circleCard.total',
            forecast: 'loyalty.circleCard.forecast',
            '% to forecast': 'loyalty.circleCard.% to forecast',
        },
        targetCircle: {
            signUps: 'loyalty.targetCircle.signUps',
            location: 'loyalty.targetCircle.location',
            forecast: 'loyalty.targetCircle.forecast',
            'target circle signups':
                'loyalty.targetCircle.target circle signups',
            'target circle 360 signups':
                'loyalty.targetCircle.target circle 360 signups',
            targetCircleSignUps: 'loyalty.targetCircle.targetCircleSignUps',
            percentToForecast: 'loyalty.targetCircle.percentToForecast',
            total: 'loyalty.targetCircle.total',
            '% to forecast': 'loyalty.targetCircle.% to forecast',
        },
    },
    brands: {
        title: 'brands.title',
        search: 'brands.search',
        clearSearch: 'brands.clearSearch',
        goBackAriaLabel: 'brands.goBackAriaLabel',
        noData: 'brands.noData',
        trend: 'brands.trend',
        headings: {
            location: 'brands.headings.location',
            sales: 'brands.headings.sales',
            orgSales: 'brands.headings.orgSales',
            fulSales: 'brands.headings.fulSales',
            originated: 'brands.headings.originated',
            shipFromStore: 'brands.headings.shipFromStore',
            orderPickup: 'brands.headings.orderPickup',
            compPercent: 'brands.headings.compPercent',
            itemDescription: 'brands.headings.itemDescription',
            quantity: 'brands.headings.quantity',
            subclass: 'brands.headings.subclass',
            loyaltyOrigTrans: 'brands.headings.loyaltyOrigTrans',
        },
        tabs: {
            top: 'brands.tabs.top',
            bottom: 'brands.tabs.bottom',
        },
    },
    storeFulfillment: {
        title: 'storeFulfillment.title',
        tabs: {
            pickup: 'storeFulfillment.tabs.pickup',
            ship: 'storeFulfillment.tabs.ship',
            inf: 'storeFulfillment.tabs.inf',
            ndd: 'storeFulfillment.tabs.ndd',
            capabilities: 'storeFulfillment.tabs.capabilities',
        },
        timePeriods: {
            today: 'storeFulfillment.timePeriods.today',
            yesterday: 'storeFulfillment.timePeriods.yesterday',
            weekToDate: 'storeFulfillment.timePeriods.weekToDate',
            lastWeek: 'storeFulfillment.timePeriods.lastWeek',
            monthToDate: 'storeFulfillment.timePeriods.monthToDate',
            yearToDate: 'storeFulfillment.timePeriods.yearToDate',
        },
        headings: {
            location: 'storeFulfillment.headings.location',
            pickup: 'storeFulfillment.headings.pickup',
            groceryPickup: 'storeFulfillment.headings.groceryPickup',
            driveUp: 'storeFulfillment.headings.driveUp',
            driveUpReturns: 'storeFulfillment.headings.driveUpReturns',
            driveUpStarbucks: 'storeFulfillment.headings.driveUpStarbucks',
            parkingLotDeliveryPause:
                'storeFulfillment.headings.parkingLotDeliveryPause',
            sfs: 'storeFulfillment.headings.sfs',
            ndd: 'storeFulfillment.headings.ndd',
            sdd: 'storeFulfillment.headings.sdd',
            infPercent: 'storeFulfillment.headings.infPercent',
            infDollars: 'storeFulfillment.headings.infDollars',
            pickedOnTime: 'storeFulfillment.headings.pickedOnTime',
            driveUpWaitTime: 'storeFulfillment.headings.driveUpWaitTime',
            openLateUnits: 'storeFulfillment.headings.openLateUnits',
            receivedUnits: 'storeFulfillment.headings.receivedUnits',
            openUnits: 'storeFulfillment.headings.openUnits',
            pickedUnitsToday: 'storeFulfillment.headings.pickedUnitsToday',
            pickedUnits: 'storeFulfillment.headings.pickedUnits',
            forecastedToday: 'storeFulfillment.headings.forecastedToday',
            totalPickupInf: 'storeFulfillment.headings.totalPickupInf',
            totalPickupAttempted:
                'storeFulfillment.headings.totalPickupAttempted',
            pickupUnitsAttempted:
                'storeFulfillment.headings.pickupUnitsAttempted',
            groceryUnitsAttempted:
                'storeFulfillment.headings.groceryUnitsAttempted',
            totalPickupPickProductivity:
                'storeFulfillment.headings.totalPickupPickProductivity',
            compPercent: 'storeFulfillment.headings.compPercent',
            forecastedUnits: 'storeFulfillment.headings.forecastedUnits',
            openUnitsCarrier: 'storeFulfillment.headings.openUnitsCarrier',
            openUnitsPack: 'storeFulfillment.headings.openUnitsPack',
            shipByTime: 'storeFulfillment.headings.shipByTime',
            sortByTime: 'storeFulfillment.headings.sortByTime',
            pick: 'storeFulfillment.headings.pick',
            pack: 'storeFulfillment.headings.pack',
            total: 'storeFulfillment.headings.total',
            teamMember: 'storeFulfillment.headings.teamMember',
            attemptedUnits: 'storeFulfillment.headings.attemptedUnits',
            picksPerHour: 'storeFulfillment.headings.picksPerHour',
            unitsPacked: 'storeFulfillment.headings.unitsPacked',
            packsPerHour: 'storeFulfillment.headings.packsPerHour',
            unitPlan: 'storeFulfillment.headings.unitPlan',
            shipOnTimePercent: 'storeFulfillment.headings.shipOnTimePercent',
            pickProductivity: 'storeFulfillment.headings.pickProductivity',
            packProductivity: 'storeFulfillment.headings.packProductivity',
            todaysWork: 'storeFulfillment.headings.todaysWork',
            carryoverUnits: 'storeFulfillment.headings.carryoverUnits',
            completedUnits: 'storeFulfillment.headings.completedUnits',
            remainingUnitPlan: 'storeFulfillment.headings.remainingUnitPlan',
            percentINF: 'storeFulfillment.headings.percentINF',
            lateUnits: 'storeFulfillment.headings.lateUnits',
            priorDayLateUnits: 'storeFulfillment.headings.priorDayLateUnits',
            priorDayCarryoverUnits:
                'storeFulfillment.headings.priorDayCarryoverUnits',
            containersToSort: 'storeFulfillment.headings.containersToSort',
            sortedOnTime: 'storeFulfillment.headings.sortedOnTime',
            handoffAccuracy: 'storeFulfillment.headings.handoffAccuracy',
            carryOverUnits: 'storeFulfillment.headings.carryOverUnits',
        },
        titles: {
            unitVolume: 'storeFulfillment.titles.unitVolume',
            teamMemberProductivity:
                'storeFulfillment.titles.teamMemberProductivity',
            todayAsOf: 'storeFulfillment.titles.todayAsOf',
            carrierPickup: 'storeFulfillment.titles.carrierPickup',
            totalUnitsToPack: 'storeFulfillment.titles.totalUnitsToPack',
            remainingAvailable: 'storeFulfillment.titles.remainingAvailable',
        },
        shipOnTimeHeadings: {
            location: 'storeFulfillment.shipOnTimeHeadings.location',
            originalPackagesDue:
                'storeFulfillment.shipOnTimeHeadings.originalPackagesDue',
            acceptedCarrierIssuePackages:
                'storeFulfillment.shipOnTimeHeadings.acceptedCarrierIssuePackages',
            totalPackagesDue:
                'storeFulfillment.shipOnTimeHeadings.totalPackagesDue',
            shipOnTimePercent:
                'storeFulfillment.shipOnTimeHeadings.shipOnTimePercent',
            packagesNotSortedOnTimePercent:
                'storeFulfillment.shipOnTimeHeadings.packagesNotSortedOnTimePercent',
            packagesNotShippedNoCarrierIssuePercent:
                'storeFulfillment.shipOnTimeHeadings.packagesNotShippedNoCarrierIssuePercent',
            mnrPackagesPercent:
                'storeFulfillment.shipOnTimeHeadings.mnrPackagesPercent',
        },
        shipOnTimeNote: 'storeFulfillment.shipOnTimeNote',
        toggles: {
            showStores: 'storeFulfillment.toggles.showStores',
            showDistricts: 'storeFulfillment.toggles.showDistricts',
        },
        ndd: {
            routeSort: 'storeFulfillment.ndd.routeSort',
            handoff: 'storeFulfillment.ndd.handoff',
            byTime: 'storeFulfillment.ndd.byTime',
            completed: 'storeFulfillment.ndd.completed',
            totalExpected: 'storeFulfillment.ndd.totalExpected',
            percentOnTime: 'storeFulfillment.ndd.percentOnTime',
            accuracy: 'storeFulfillment.ndd.accuracy',
            asOf: 'storeFulfillment.ndd.asOf',
            containersSorted: 'storeFulfillment.ndd.containersSorted',
            infPercent: 'storeFulfillment.ndd.infPercent',
            sortedOnTime: 'storeFulfillment.ndd.sortedOnTime',
            shippedOnTime: 'storeFulfillment.ndd.shippedOnTime',
        },
        inf: {
            store: {
                orderPickupOPU: 'storeFulfillment.inf.store.orderPickupOPU',
                units: 'storeFulfillment.inf.store.units',
                dollars: 'storeFulfillment.inf.store.dollars',
                inf: 'storeFulfillment.inf.store.inf',
                sfs: 'storeFulfillment.inf.store.sfs',
                shipFromStoreSFS: 'storeFulfillment.inf.store.shipFromStoreSFS',
                infTime: 'storeFulfillment.inf.store.infTime',
                infUnits: 'storeFulfillment.inf.store.infUnits',
                attemptedUnits: 'storeFulfillment.inf.store.attemptedUnits',
                dpci: 'storeFulfillment.inf.store.dpci',
                item: 'storeFulfillment.inf.store.item',
                teamMember: 'storeFulfillment.inf.store.teamMember',
                totalMinutes: 'storeFulfillment.inf.store.totalMinutes',
                orderNumber: 'storeFulfillment.inf.store.orderNumber',
                asOf: 'storeFulfillment.inf.store.asOf',
                capabilityStatus: 'storeFulfillment.inf.store.capabilityStatus',
                ON: 'storeFulfillment.inf.store.ON',
                OFF: 'storeFulfillment.inf.store.OFF',
                PAUSED: 'storeFulfillment.inf.store.PAUSED',
                lastUpdated: 'storeFulfillment.inf.store.lastUpdated',
                reason: 'storeFulfillment.inf.store.reason',
                department: 'storeFulfillment.inf.store.department',
            },
            rgdHeadings: {
                pickup: {
                    totalPickupInf:
                        'storeFulfillment.inf.rgdHeadings.pickup.totalPickupInf',
                    pickupINFApparel:
                        'storeFulfillment.inf.rgdHeadings.pickup.pickupINFApparel',
                    pickupINFBeauty:
                        'storeFulfillment.inf.rgdHeadings.pickup.pickupINFBeauty',
                    pickupINFFoodBeverage:
                        'storeFulfillment.inf.rgdHeadings.pickup.pickupINFFoodBeverage',
                    pickupINFHardlines:
                        'storeFulfillment.inf.rgdHeadings.pickup.pickupINFHardlines',
                    pickupINFHome:
                        'storeFulfillment.inf.rgdHeadings.pickup.pickupINFHome',
                },
                ship: {
                    totalShipINF:
                        'storeFulfillment.inf.rgdHeadings.ship.totalShipINF',
                    shipINFApparel:
                        'storeFulfillment.inf.rgdHeadings.ship.shipINFApparel',
                    shipINFBeauty:
                        'storeFulfillment.inf.rgdHeadings.ship.shipINFBeauty',
                    shipINFFoodBeverage:
                        'storeFulfillment.inf.rgdHeadings.ship.shipINFFoodBeverage',
                    shipINFHardlines:
                        'storeFulfillment.inf.rgdHeadings.ship.shipINFHardlines',
                    shipINFHome:
                        'storeFulfillment.inf.rgdHeadings.ship.shipINFHome',
                },
                tableHeaders: {
                    units: 'storeFulfillment.inf.rgdHeadings.tableHeaders.units',
                    dollars:
                        'storeFulfillment.inf.rgdHeadings.tableHeaders.dollars',
                    inf: 'storeFulfillment.inf.rgdHeadings.tableHeaders.inf',
                },
            },
        },
        unitsCompletedLabel: 'storeFulfillment.unitsCompletedLabel',
    },
    payroll: {
        title: 'payroll.title',
        planHrs: 'payroll.planHrs',
        actRemSchedHrs: 'payroll.actRemSchedHrs',
        weekNo: 'payroll.weekNo',
        payrollRegion: 'payroll.payrollRegion',
        tabs: {
            location: 'payroll.tabs.location',
            workgroup: 'payroll.tabs.workgroup',
            overtime: 'payroll.tabs.overtime',
            monthly: 'payroll.tabs.monthly',
        },
        location: {
            title: 'payroll.location.title',
            loc: 'payroll.location.loc',
            payrollByLocation: 'payroll.location.payrollByLocation',
            payrollByWeek: 'payroll.location.payrollByWeek',
            projFlexHours: 'payroll.location.projFlexHours',
            trailerFlexHours: 'payroll.location.trailerFlexHours',
            adjustments: 'payroll.location.adjustments',
            asOf: 'payroll.location.asOf',
            location: 'payroll.location.location',
            variance: 'payroll.location.variance',
            thisMonth: 'payroll.location.thisMonth',
            lastMonth: 'payroll.location.lastMonth',
            nextMonth: 'payroll.location.nextMonth',
            nextMonthUnavailable: 'payroll.location.nextMonthUnavailable',
            otherAdjustments: 'payroll.location.otherAdjustments',
            projFlexHrs: 'payroll.location.projFlexHrs',
            trailerFlex: 'payroll.location.trailerFlex',
        },
        workgroup: {
            title: 'payroll.workgroup.title',
            workGroup: 'payroll.workgroup.workGroup',
        },
        overtime: {
            title: 'payroll.overtime.title',
            actualPct: 'payroll.overtime.actualPct',
            lyAdMappedPct: 'payroll.overtime.lyAdMappedPct',
            bpTtoLyAdMappedPct: 'payroll.overtime.bpTtoLyAdMappedPct',
        },
    },
    itemSearch: {
        title: 'itemSearch.title',
        searchLabel: 'itemSearch.searchLabel',
        searchButtonText: 'itemSearch.searchButtonText',
        searchInputPlaceholder: 'itemSearch.searchInputPlaceholder',
        searchInputPlaceholderZebra: 'itemSearch.searchInputPlaceholderZebra',
        scanButtonAriaLabel: 'itemSearch.scanButtonAriaLabel',
        dpciLabel: 'itemSearch.dpciLabel',
        dpciAriaLabel: 'itemSearch.dpciAriaLabel',
        placementCapacityDescription: 'itemSearch.placementCapacityDescription',
        onHandRow: 'itemSearch.onHandRow',
        onWithdrawalRow: 'itemSearch.onWithdrawalRow',
        lastAuditedRow: 'itemSearch.lastAuditedRow',
        lastReceivedRow: 'itemSearch.lastReceivedRow',
        lastSoldRow: 'itemSearch.lastSoldRow',
        totalSalesCardTitle: 'itemSearch.totalSalesCardTitle',
        averageSalesCardTitle: 'itemSearch.averageSalesCardTitle',
        location: 'itemSearch.location',
        company: 'itemSearch.company',
        district: 'itemSearch.district',
        store: 'itemSearch.store',
        unitsSold: 'itemSearch.unitsSold',
        sales: 'itemSearch.sales',
        itemNotFound: 'itemSearch.itemNotFound',
        stopScanning: 'itemSearch.stopScanning',
        quantityCheck: 'itemSearch.quantityCheck',
        tabs: {
            actual: 'itemSearch.tabs.actual',
            forecast: 'itemSearch.tabs.forecast',
        },
    },
    safety: {
        title: 'safety.title',
        lagging: {
            title: 'safety.lagging.title',
            Location: 'safety.lagging.Location',
            'Guest Incident Rate': 'safety.lagging.Guest Incident Rate',
            'TM Inj 8wk Rate': 'safety.lagging.TM Inj 8wk Rate',
            'TM Inj YTD Rate': 'safety.lagging.TM Inj YTD Rate',
            Company: 'safety.lagging.Company',
        },
        total: {
            title: 'safety.total.title',
            Location: 'safety.total.Location',
            'All TM Reported YTD ': 'safety.total.All TM Reported YTD ',
            'All Guest Reported YTD': 'safety.total.All Guest Reported YTD',
            'Hazards/Near Misses': 'safety.total.Hazards/Near Misses',
            Company: 'safety.total.Company',
        },
        leading: {
            title: 'safety.leading.title',
            Location: 'safety.leading.Location',
            'Safety Meetings': 'safety.leading.Safety Meetings',
            Observations: 'safety.leading.Observations',
            'Action Plans': 'safety.leading.Action Plans',
            Investigations: 'safety.leading.Investigations',
            'Invest Action Plans': 'safety.leading.Invest Action Plans',
            Company: 'safety.leading.Company',
        },
        tabs: {
            lagging: 'safety.tabs.lagging',
            total: 'safety.tabs.total',
            leading: 'safety.tabs.leading',
        },
        nonStoreLabel: 'safety.nonStoreLabel',
        store: {
            'Lagging Indicators': 'safety.store.Lagging Indicators',
            'Total Incidents': 'safety.store.Total Incidents',
            'Leading Indicators': 'safety.store.Leading Indicators',
        },
    },
    sales: {
        title: 'sales.title',
        noPermission: 'sales.noPermission',
        tabs: {
            overview: 'sales.tabs.overview',
            details: 'sales.tabs.details',
            location: 'sales.tabs.location',
        },
        timePeriods: {
            today: 'sales.timePeriods.today',
            yesterday: 'sales.timePeriods.yesterday',
            weekToDate: 'sales.timePeriods.weekToDate',
            lastWeek: 'sales.timePeriods.lastWeek',
            monthToDate: 'sales.timePeriods.monthToDate',
            lastMonth: 'sales.timePeriods.lastMonth',
            yearToDate: 'sales.timePeriods.yearToDate',
        },
        filters: {
            compPercent: 'sales.filters.compPercent',
            viewInDollars: 'sales.filters.viewInDollars',
            viewInPercent: 'sales.filters.viewInPercent',
        },
        overview: {
            hourlySales: 'sales.overview.hourlySales',
            originated: 'sales.overview.originated',
            lineBusting: 'sales.overview.lineBusting',
            fulfilled: 'sales.overview.fulfilled',
            shipFromStore: 'sales.overview.shipFromStore',
            driveUp: 'sales.overview.driveUp',
            orderPickup: 'sales.overview.orderPickup',
            shipt: 'sales.overview.shipt',
            otherSales: 'sales.overview.otherSales',
            saveTheSale: 'sales.overview.saveTheSale',
            goal: 'sales.overview.goal',
            lastYear: 'sales.overview.lastYear',
            compPercent: 'sales.overview.compPercent',
            originatedCompPercent: 'sales.overview.originatedCompPercent',
            fulfilledCompPercent: 'sales.overview.fulfilledCompPercent',
            twoYearCagr: 'sales.overview.twoYearCagr',
            basketSize: 'sales.overview.basketSize',
            transactions: 'sales.overview.transactions',
            total: 'sales.overview.total',
            ly: 'sales.overview.ly',
            bpToLy: 'sales.overview.bpToLy',
            bpToLyPercent: 'sales.overview.bpToLyPercent',
            goalPercentage: 'sales.overview.goalPercentage',
            of: 'sales.overview.of',
            basketSizeDollar: 'sales.overview.basketSizeDollar',
            basketSizeUnits: 'sales.overview.basketSizeUnits',
        },
        details: {
            workarea: {
                title: 'sales.details.workarea.title',
                tabs: {
                    sales: 'sales.details.workarea.tabs.sales',
                    salesMix: 'sales.details.workarea.tabs.salesMix',
                    timePeriods: {
                        today: 'sales.details.workarea.tabs.timePeriods.today',
                        yesterday:
                            'sales.details.workarea.tabs.timePeriods.yesterday',
                        weekToDate:
                            'sales.details.workarea.tabs.timePeriods.weekToDate',
                        lastWeek:
                            'sales.details.workarea.tabs.timePeriods.lastWeek',
                        monthToDay:
                            'sales.details.workarea.tabs.timePeriods.monthToDay',
                        yearToDay:
                            'sales.details.workarea.tabs.timePeriods.yearToDay',
                    },
                    merch: 'sales.details.workarea.tabs.merch',
                    'orig. sales': 'sales.details.workarea.tabs.orig. sales',
                    'ful. sales': 'sales.details.workarea.tabs.ful. sales',
                },
            },
            merch: {
                title: 'sales.details.merch.title',
                tabs: {
                    sales: 'sales.details.merch.tabs.sales',
                    salesMix: 'sales.details.merch.tabs.salesMix',
                    timePeriods: {
                        today: 'sales.details.merch.tabs.timePeriods.today',
                        yesterday:
                            'sales.details.merch.tabs.timePeriods.yesterday',
                        weekToDate:
                            'sales.details.merch.tabs.timePeriods.weekToDate',
                        lastWeek:
                            'sales.details.merch.tabs.timePeriods.lastWeek',
                        monthToDay:
                            'sales.details.merch.tabs.timePeriods.monthToDay',
                        yearToDay:
                            'sales.details.merch.tabs.timePeriods.yearToDay',
                    },
                    merch: 'sales.details.merch.tabs.merch',
                    'orig. sales': 'sales.details.merch.tabs.orig. sales',
                    'ful. sales': 'sales.details.merch.tabs.ful. sales',
                },
            },
        },
        location: {
            title: 'sales.location.title',
            tabs: {
                region: 'sales.location.tabs.region',
                Region: 'sales.location.tabs.Region',
                group: 'sales.location.tabs.group',
                district: 'sales.location.tabs.district',
                store: 'sales.location.tabs.store',
                sales: 'sales.location.tabs.sales',
                goal: 'sales.location.tabs.goal',
                forecast: 'sales.location.tabs.forecast',
                'variance %': 'sales.location.tabs.variance %',
                variance: 'sales.location.tabs.variance',
                compPercent: 'sales.location.tabs.compPercent',
                'comp %': 'sales.location.tabs.comp %',
                'ly ad mapped': 'sales.location.tabs.ly ad mapped',
                '2 yr cagr %': 'sales.location.tabs.2 yr cagr %',
            },
        },
        hourly: {
            hour: 'sales.hourly.hour',
            today: 'sales.hourly.today',
            variance: 'sales.hourly.variance',
            lyAdMapped: 'sales.hourly.lyAdMapped',
            Transaction_count: 'sales.hourly.Transaction_count',
            'Basket Size $': 'sales.hourly.Basket Size $',
            'Basket Size U': 'sales.hourly.Basket Size U',
            'Basket $ b/(P) % LY': 'sales.hourly.Basket $ b/(P) % LY',
            'Basket Units b/(P) % LY': 'sales.hourly.Basket Units b/(P) % LY',
            'Transaction Count b/(P) % LY':
                'sales.hourly.Transaction Count b/(P) % LY',
        },
    },
    shortage: {
        title: 'shortage.title',
        totalShortage: 'shortage.totalShortage',
        'last inventory date': 'shortage.last inventory date',
        'next scheduled inventory date':
            'shortage.next scheduled inventory date',
        thisYear: {
            title: 'shortage.thisYear.title',
        },
        merch: {
            title: 'shortage.merch.title',
        },
        top10: {
            title: 'shortage.top10.title',
        },
        filters: {
            viewInDollars: 'shortage.filters.viewInDollars',
            viewInPercent: 'shortage.filters.viewInPercent',
        },
        table: {
            merch: 'shortage.table.merch',
            dept: 'shortage.table.dept',
            class: 'shortage.table.class',
            'focus areas': 'shortage.table.focus areas',
            'shortage $': 'shortage.table.shortage $',
            'b/p ly $': 'shortage.table.b/p ly $',
            'b(p) ly $': 'shortage.table.b(p) ly $',
            'shortage %': 'shortage.table.shortage %',
            'b/p ly %': 'shortage.table.b/p ly %',
            'b(p) ly %': 'shortage.table.b(p) ly %',
            location: 'shortage.table.location',
            'gm $': 'shortage.table.gm $',
            'gm % ': 'shortage.table.gm % ',
            'perishable $': 'shortage.table.perishable $',
            'perishable % ': 'shortage.table.perishable % ',
            region: 'shortage.table.region',
            group: 'shortage.table.group',
            district: 'shortage.table.district',
        },
    },
    storeFacts: {
        title: 'storeFacts.title',
        quickFacts: 'storeFacts.quickFacts',
        lastYearSales: 'storeFacts.lastYearSales',
        originatedSales: 'storeFacts.originatedSales',
        fulfilledSales: 'storeFacts.fulfilledSales',
        totalSales: 'storeFacts.totalSales',
        hours: 'storeFacts.hours',
        keyDates: 'storeFacts.keyDates',
        opened: 'storeFacts.opened',
        lastRemodel: 'storeFacts.lastRemodel',
        notAvailable: 'storeFacts.notAvailable',
        packStation: 'storeFacts.packStation',
        leadership: 'storeFacts.leadership',
        store: 'storeFacts.store',
        role: 'storeFacts.role',
        name: 'storeFacts.name',
        since: 'storeFacts.since',
        capabilities: 'storeFacts.capabilities',
        to: 'storeFacts.to',
        field: 'storeFacts.field',
        inboundNodes: 'storeFacts.inboundNodes',
        outboundNodes: 'storeFacts.outboundNodes',
    },
    myTargetPerformance: {
        title: 'myTargetPerformance.title',
        noMetricsAvailable: 'myTargetPerformance.noMetricsAvailable',
        tabs: {
            guest: 'myTargetPerformance.tabs.guest',
            financial: 'myTargetPerformance.tabs.financial',
            team: 'myTargetPerformance.tabs.team',
        },
        historicalDetails: 'myTargetPerformance.historicalDetails',
        goal: 'myTargetPerformance.goal',
        seeDetails: 'myTargetPerformance.seeDetails',
        pctGreenStores: 'myTargetPerformance.pctGreenStores',
        location: 'myTargetPerformance.location',
        company: 'myTargetPerformance.company',
        sections: {
            financial: 'myTargetPerformance.sections.financial',
            guestCompliance: 'myTargetPerformance.sections.guestCompliance',
            guestEngagement: 'myTargetPerformance.sections.guestEngagement',
            guestImpact: 'myTargetPerformance.sections.guestImpact',
            guestReadiness: 'myTargetPerformance.sections.guestReadiness',
            guestSatisfaction: 'myTargetPerformance.sections.guestSatisfaction',
            team: 'myTargetPerformance.sections.team',
        },
        metricTypes: {
            outcomes: 'myTargetPerformance.metricTypes.outcomes',
            levers: 'myTargetPerformance.metricTypes.levers',
        },
        timePeriods: {
            priorDay: 'myTargetPerformance.timePeriods.priorDay',
            priorWeek: 'myTargetPerformance.timePeriods.priorWeek',
            last4Weeks: 'myTargetPerformance.timePeriods.last4Weeks',
            priorMonth: 'myTargetPerformance.timePeriods.priorMonth',
            priorQuarter: 'myTargetPerformance.timePeriods.priorQuarter',
            priorYear: 'myTargetPerformance.timePeriods.priorYear',
            weekToDay: 'myTargetPerformance.timePeriods.weekToDay',
            monthToDay: 'myTargetPerformance.timePeriods.monthToDay',
            monthToWeek: 'myTargetPerformance.timePeriods.monthToWeek',
            quarterToWeek: 'myTargetPerformance.timePeriods.quarterToWeek',
            yearToDay: 'myTargetPerformance.timePeriods.yearToDay',
            yearToWeek: 'myTargetPerformance.timePeriods.yearToWeek',
        },
        timePeriodLabels: {
            priorDay: 'myTargetPerformance.timePeriodLabels.priorDay',
            priorWeek: 'myTargetPerformance.timePeriodLabels.priorWeek',
            last4Weeks: 'myTargetPerformance.timePeriodLabels.last4Weeks',
            priorMonth: 'myTargetPerformance.timePeriodLabels.priorMonth',
            priorQuarter: 'myTargetPerformance.timePeriodLabels.priorQuarter',
            priorYear: 'myTargetPerformance.timePeriodLabels.priorYear',
            weekToDay: 'myTargetPerformance.timePeriodLabels.weekToDay',
            monthToDay: 'myTargetPerformance.timePeriodLabels.monthToDay',
            monthToWeek: 'myTargetPerformance.timePeriodLabels.monthToWeek',
            quarterToWeek: 'myTargetPerformance.timePeriodLabels.quarterToWeek',
            yearToDay: 'myTargetPerformance.timePeriodLabels.yearToDay',
            yearToWeek: 'myTargetPerformance.timePeriodLabels.yearToWeek',
        },
    },
    notes: {
        notes: 'notes.notes',
        sales: 'notes.sales',
        of: 'notes.of',
        payroll: 'notes.payroll',
        hours: 'notes.hours',
        flexPlan: 'notes.flexPlan',
        weather: 'notes.weather',
        keyStatistics: 'notes.keyStatistics',
        'at goal': 'notes.at goal',
        'below goal': 'notes.below goal',
        pickOnTime: 'notes.pickOnTime',
        sfsInf: 'notes.sfsInf',
        opuInf: 'notes.opuInf',
        high: 'notes.high',
        low: 'notes.low',
        comp: 'notes.comp',
        errorText: 'notes.errorText',
        datePickerLabel: 'notes.datePickerLabel',
        permissions: {
            noAccess: 'notes.permissions.noAccess',
            noNotesPermissions: 'notes.permissions.noNotesPermissions',
            userLocationNotAvailable:
                'notes.permissions.userLocationNotAvailable',
            accessDeniedLocation: 'notes.permissions.accessDeniedLocation',
            writeAccessLimited: 'notes.permissions.writeAccessLimited',
        },
        items: {
            addButton: 'notes.items.addButton',
            editButton: 'notes.items.editButton',
            deleteButton: 'notes.items.deleteButton',
            todo: {
                title: 'notes.items.todo.title',
                label: 'notes.items.todo.label',
                key: 'notes.items.todo.key',
            },
            attendance: {
                title: 'notes.items.attendance.title',
                label: 'notes.items.attendance.label',
                key: 'notes.items.attendance.key',
            },
            notes: {
                title: 'notes.items.notes.title',
                label: 'notes.items.notes.label',
                key: 'notes.items.notes.key',
            },
            updateButton: 'notes.items.updateButton',
            deleteConfirmTitle: 'notes.items.deleteConfirmTitle',
            cancelButton: 'notes.items.cancelButton',
            confirmButton: 'notes.items.confirmButton',
        },
        legacy: {
            title: 'notes.legacy.title',
            subtitle: 'notes.legacy.subtitle',
        },
    },
    operationalMetrics: {
        title: 'operationalMetrics.title',
        historicalDetails: 'operationalMetrics.historicalDetails',
        seeChartView: 'operationalMetrics.seeChartView',
        recall: {
            tabs: {
                operations: 'operationalMetrics.recall.tabs.operations',
                recall: 'operationalMetrics.recall.tabs.recall',
                incompleteRecalls:
                    'operationalMetrics.recall.tabs.incompleteRecalls',
            },
            search: {
                label: 'operationalMetrics.recall.search.label',
                placeholder: 'operationalMetrics.recall.search.placeholder',
                noResults: 'operationalMetrics.recall.search.noResults',
                clearAriaLabel:
                    'operationalMetrics.recall.search.clearAriaLabel',
            },
            headings: {
                location: 'operationalMetrics.recall.headings.location',
                store: 'operationalMetrics.recall.headings.store',
                district: 'operationalMetrics.recall.headings.district',
                group: 'operationalMetrics.recall.headings.group',
                region: 'operationalMetrics.recall.headings.region',
                irNumber: 'operationalMetrics.recall.headings.irNumber',
            },
        },
        timePeriods: {
            priorDay: 'operationalMetrics.timePeriods.priorDay',
            weekToDay: 'operationalMetrics.timePeriods.weekToDay',
            priorWeek: 'operationalMetrics.timePeriods.priorWeek',
            monthToDay: 'operationalMetrics.timePeriods.monthToDay',
            priorMonth: 'operationalMetrics.timePeriods.priorMonth',
            yearToDay: 'operationalMetrics.timePeriods.yearToDay',
        },
        headers: {
            needsAttention: 'operationalMetrics.headers.needsAttention',
            atGoal: 'operationalMetrics.headers.atGoal',
            belowGoal: 'operationalMetrics.headers.belowGoal',
        },
        detailsColumns: {
            location: 'operationalMetrics.detailsColumns.location',
            'area of store': 'operationalMetrics.detailsColumns.area of store',
            'INF units': 'operationalMetrics.detailsColumns.INF units',
            'total attempted units':
                'operationalMetrics.detailsColumns.total attempted units',
            'INF $': 'operationalMetrics.detailsColumns.INF $',
            'INF %': 'operationalMetrics.detailsColumns.INF %',
            'Total Picks Attempted':
                'operationalMetrics.detailsColumns.Total Picks Attempted',
            'Total Units INF %':
                'operationalMetrics.detailsColumns.Total Units INF %',
            'Total Units INF':
                'operationalMetrics.detailsColumns.Total Units INF',
            'Total INF $': 'operationalMetrics.detailsColumns.Total INF $',
            '% of Stores Meeting Goal':
                'operationalMetrics.detailsColumns.% of Stores Meeting Goal',
            'BAI %': 'operationalMetrics.detailsColumns.BAI %',
        },
        operationsCards: {
            'Pick On Time %':
                'operationalMetrics.operationsCards.Pick On Time %',
            'Total Picks Attempted':
                'operationalMetrics.operationsCards.Total Picks Attempted',
            'Total Units Picked On Time':
                'operationalMetrics.operationsCards.Total Units Picked On Time',
            'SFS INF %': 'operationalMetrics.operationsCards.SFS INF %',
            'Pick Up INF %': 'operationalMetrics.operationsCards.Pick Up INF %',
            'Ship On-Time %':
                'operationalMetrics.operationsCards.Ship On-Time %',
            'Total Units Due To Ship Today':
                'operationalMetrics.operationsCards.Total Units Due To Ship Today',
            'Return to Stock':
                'operationalMetrics.operationsCards.Return to Stock',
            'Total RTS Tasks':
                'operationalMetrics.operationsCards.Total RTS Tasks',
            'Drive Up Wait Time':
                'operationalMetrics.operationsCards.Drive Up Wait Time',
            'Delivery Trips':
                'operationalMetrics.operationsCards.Delivery Trips',
            'Total Priority Fill %':
                'operationalMetrics.operationsCards.Total Priority Fill %',
            'OSA Store Addressable Lost Sales':
                'operationalMetrics.operationsCards.OSA Store Addressable Lost Sales',
            'Store Addressable Lost Sales %':
                'operationalMetrics.operationsCards.Store Addressable Lost Sales %',
            'Never Outs: OSA Store Addressable Lost Sales':
                'operationalMetrics.operationsCards.Never Outs: OSA Store Addressable Lost Sales',
            'Event Activations':
                'operationalMetrics.operationsCards.Event Activations',
            'Total Events Activated':
                'operationalMetrics.operationsCards.Total Events Activated',
            'Ticketed/Salvage Unit Accuracy %':
                'operationalMetrics.operationsCards.Ticketed/Salvage Unit Accuracy %',
            'Total Actual Units':
                'operationalMetrics.operationsCards.Total Actual Units',
            'Guest Price Chal %':
                'operationalMetrics.operationsCards.Guest Price Chal %',
            '# Tasks': 'operationalMetrics.operationsCards.# Tasks',
            '# of Tasks': 'operationalMetrics.operationsCards.# of Tasks',
            'RFID Compliance %':
                'operationalMetrics.operationsCards.RFID Compliance %',
            'Scan %': 'operationalMetrics.operationsCards.Scan %',
            'Backroom Audit Completion %':
                'operationalMetrics.operationsCards.Backroom Audit Completion %',
            'Backroom Audit Tasks':
                'operationalMetrics.operationsCards.Backroom Audit Tasks',
            'Sales Floor Audit Completion %':
                'operationalMetrics.operationsCards.Sales Floor Audit Completion %',
            'Suspect Task': 'operationalMetrics.operationsCards.Suspect Task',
            'Belted Lane Utilization %':
                'operationalMetrics.operationsCards.Belted Lane Utilization %',
            'Self Checkout Utilization %':
                'operationalMetrics.operationsCards.Self Checkout Utilization %',
            'Check Date Completion %':
                'operationalMetrics.operationsCards.Check Date Completion %',
            'Check Date Completion % (FOOD & BEVERAGE)':
                'operationalMetrics.operationsCards.Check Date Completion % (FOOD & BEVERAGE)',
            'Check Date Completion % (ESSENTIALS & BEAUTY)':
                'operationalMetrics.operationsCards.Check Date Completion % (ESSENTIALS & BEAUTY)',
            '# DPCI Pulled': 'operationalMetrics.operationsCards.# DPCI Pulled',
            'Drive Up TM Interaction':
                'operationalMetrics.operationsCards.Drive Up TM Interaction',
            'Drive Up TM Interaction LY':
                'operationalMetrics.operationsCards.Drive Up TM Interaction LY',
            'Set On-Time %': 'operationalMetrics.operationsCards.Set On-Time %',
            '# of POGs Due': 'operationalMetrics.operationsCards.# of POGs Due',
            'ESIM Completion %':
                'operationalMetrics.operationsCards.ESIM Completion %',
            'Completed Log': 'operationalMetrics.operationsCards.Completed Log',
            'Wait Time at Checkout':
                'operationalMetrics.operationsCards.Wait Time at Checkout',
            'TM Interaction at Checkout':
                'operationalMetrics.operationsCards.TM Interaction at Checkout',
            'Order Pickup TM Interaction':
                'operationalMetrics.operationsCards.Order Pickup TM Interaction',
            'Order Pickup TM Interaction LY':
                'operationalMetrics.operationsCards.Order Pickup TM Interaction LY',
            'Salesfloor TM Interaction':
                'operationalMetrics.operationsCards.Salesfloor TM Interaction',
            Cleanliness: 'operationalMetrics.operationsCards.Cleanliness',
            'Backroom Accuracy Indicator':
                'operationalMetrics.operationsCards.Backroom Accuracy Indicator',
            '% of Stores Meeting Goal':
                'operationalMetrics.operationsCards.% of Stores Meeting Goal',
            'Pick Up Quality Defect %':
                'operationalMetrics.operationsCards.Pick Up Quality Defect %',
            'Total Defect Units':
                'operationalMetrics.operationsCards.Total Defect Units',
            'Salvage Fill Completion %':
                'operationalMetrics.operationsCards.Salvage Fill Completion %',
            'Tasks Completed':
                'operationalMetrics.operationsCards.Tasks Completed',
            'Price Change %':
                'operationalMetrics.operationsCards.Price Change %',
            'Task Actuals': 'operationalMetrics.operationsCards.Task Actuals',
            'Price Audit %': 'operationalMetrics.operationsCards.Price Audit %',
            'Task Expected': 'operationalMetrics.operationsCards.Task Expected',
            'SFS Total Defect Rate %':
                'operationalMetrics.operationsCards.SFS Total Defect Rate %',
        },
    },
    trailer: {
        title: 'trailer.title',
        tabs: {
            summary: 'trailer.tabs.summary',
            schedule: 'trailer.tabs.schedule',
        },
        summary: {
            unacknowledgedDcTitle: 'trailer.summary.unacknowledgedDcTitle',
            unacknowledgedStoreTitle:
                'trailer.summary.unacknowledgedStoreTitle',
            unacknowledgedTransitTitle:
                'trailer.summary.unacknowledgedTransitTitle',
            unacknowledgedNoTrackingTitle:
                'trailer.summary.unacknowledgedNoTrackingTitle',
            acknowledgedTitle: 'trailer.summary.acknowledgedTitle',
        },
        schedule: {
            title: 'trailer.schedule.title',
            timePeriods: {
                currentWeek: 'trailer.schedule.timePeriods.currentWeek',
                lastWeek: 'trailer.schedule.timePeriods.lastWeek',
                nextWeek: 'trailer.schedule.timePeriods.nextWeek',
                threeWeeksOut: 'trailer.schedule.timePeriods.threeWeeksOut',
                fourWeeksOut: 'trailer.schedule.timePeriods.fourWeeksOut',
            },
            headers: {
                unloadDateTime: 'trailer.schedule.headers.unloadDateTime',
                sequence: 'trailer.schedule.headers.sequence',
                type: 'trailer.schedule.headers.type',
                sweep: 'trailer.schedule.headers.sweep',
            },
        },
        toggles: {
            showRDC: 'trailer.toggles.showRDC',
            showFDC: 'trailer.toggles.showFDC',
        },
        rgd: {
            location: 'trailer.rgd.location',
            unacknowledged: 'trailer.rgd.unacknowledged',
            red: 'trailer.rgd.red',
            recentlyAcknowledged: 'trailer.rgd.recentlyAcknowledged',
            today: 'trailer.rgd.today',
        },
        details: {
            zeroHours: 'trailer.details.zeroHours',
            billOfLading: 'trailer.details.billOfLading',
            unknownMiles: 'trailer.details.unknownMiles',
            miles: 'trailer.details.miles',
            lastApplication: 'trailer.details.lastApplication',
            table: {
                type: 'trailer.details.table.type',
                acknowledged: 'trailer.details.table.acknowledged',
                closed: 'trailer.details.table.closed',
                trailerNumber: 'trailer.details.table.trailerNumber',
                cartons: 'trailer.details.table.cartons',
                leadTime: 'trailer.details.table.leadTime',
                laborHours: 'trailer.details.table.laborHours',
                stockingTime: 'trailer.details.table.stockingTime',
                secondarySortingTime:
                    'trailer.details.table.secondarySortingTime',
                customBlock: 'trailer.details.table.customBlock',
                loadZone: 'trailer.details.table.loadZone',
                caseCartons: 'trailer.details.table.caseCartons',
                repackCartons: 'trailer.details.table.repackCartons',
                sortingTime: 'trailer.details.table.sortingTime',
                total: 'trailer.details.table.total',
                bulk: 'trailer.details.table.bulk',
                description: 'trailer.details.table.description',
                eaches: 'trailer.details.table.eaches',
                dpci: 'trailer.details.table.dpci',
            },
            workArea: {
                workArea: 'trailer.details.workArea.workArea',
                caseCartons: 'trailer.details.workArea.caseCartons',
                caseUnit: 'trailer.details.workArea.caseUnit',
                repackCartons: 'trailer.details.workArea.repackCartons',
                repackUnits: 'trailer.details.workArea.repackUnits',
                total: 'trailer.details.workArea.total',
            },
        },
        trailerNotFound: 'trailer.trailerNotFound',
    },
    settings: {
        title: 'settings.title',
        info: 'settings.info',
        you: 'settings.you',
        location: 'settings.location',
        version: 'settings.version',
        help: 'settings.help',
        feedback: 'settings.feedback',
        language: 'settings.language',
        languages: {
            en: 'settings.languages.en',
            es: 'settings.languages.es',
            EN: 'settings.languages.EN',
            ES: 'settings.languages.ES',
        },
        landingPage: 'settings.landingPage',
        landingPageDescription: 'settings.landingPageDescription',
        map: 'settings.map',
        preferredMap: 'settings.preferredMap',
        mapMessage: 'settings.mapMessage',
        maps: {
            google: 'settings.maps.google',
            apple: 'settings.maps.apple',
        },
        creatingPreferences: 'settings.creatingPreferences',
        updatingPreferences: 'settings.updatingPreferences',
        looksLikeSomethingWentWrong: 'settings.looksLikeSomethingWentWrong',
        loading: 'settings.loading',
    },
    unauthorized: {
        title: 'unauthorized.title',
        message: 'unauthorized.message',
        forbiddenMessage: 'unauthorized.forbiddenMessage',
        notFoundTitle: 'unauthorized.notFoundTitle',
        notFoundMessage: 'unauthorized.notFoundMessage',
        noUserDetailsData: 'unauthorized.noUserDetailsData',
    },
    transientError: {
        title: 'transientError.title',
        message: 'transientError.message',
        retryButton: 'transientError.retryButton',
    },
    generalErrors: {
        loadFailedRetry: 'generalErrors.loadFailedRetry',
    },
    contact: {
        mainPhone: 'contact.mainPhone',
        fax: 'contact.fax',
    },
    location: {
        region: 'location.region',
        group: 'location.group',
        district: 'location.district',
        RDC: 'location.RDC',
        county: 'location.county',
    },
    timePeriods: {
        today: 'timePeriods.today',
        yesterday: 'timePeriods.yesterday',
        weekToDate: 'timePeriods.weekToDate',
        lastWeek: 'timePeriods.lastWeek',
        monthToDate: 'timePeriods.monthToDate',
        lastMonth: 'timePeriods.lastMonth',
        yearToDate: 'timePeriods.yearToDate',
    },
    filters: {
        compPercent: 'filters.compPercent',
        viewInPercent: 'filters.viewInPercent',
        viewInDollars: 'filters.viewInDollars',
        viewItem: 'filters.viewItem',
        viewSubclass: 'filters.viewSubclass',
    },
    feedback: {
        thankYou: 'feedback.thankYou',
        thankYouForSubmitting: 'feedback.thankYouForSubmitting',
        error: 'feedback.error',
        errorSubmitting: 'feedback.errorSubmitting',
        sendAMessage: 'feedback.sendAMessage',
        message: 'feedback.message',
        hereToHelp: 'feedback.hereToHelp',
        submitFeedback: 'feedback.submitFeedback',
        shareFeedback: 'feedback.shareFeedback',
        footerAriaLabel: 'feedback.footerAriaLabel',
    },
    'weekly hours': 'weekly hours',
    'prior month': 'prior month',
    'Actual Hrs': 'Actual Hrs',
    'Plan Hrs': 'Plan Hrs',
    'Published Hrs': 'Published Hrs',
    'b/(p) to Plan': 'b/(p) to Plan',
    'b/(p) % to Plan': 'b/(p) % to Plan',
    'b/(p) % to Published': 'b/(p) % to Published',
    'Eastern Standard Time': 'Eastern Standard Time',
    'Central Standard Time': 'Central Standard Time',
    'Mountain Standard Time': 'Mountain Standard Time',
    'Pacific Standard Time': 'Pacific Standard Time',
    EST: 'EST',
    CST: 'CST',
    MST: 'MST',
    PST: 'PST',
    'pack station': 'pack station',
    'Adult Beverage Pickup': 'Adult Beverage Pickup',
    'Wine & Beer Available': 'Wine & Beer Available',
    'Beer Available': 'Beer Available',
    'Drive Up': 'Drive Up',
    'Starbucks Drive Up': 'Starbucks Drive Up',
    'Vandal Resistant Glass': 'Vandal Resistant Glass',
    'Fresh Order Pick Up': 'Fresh Order Pick Up',
    'Self Checkout': 'Self Checkout',
    'Accepts WIC': 'Accepts WIC',
    'Protects brands advocates in court safer shopping':
        'Protects brands advocates in court safer shopping',
    'Shipt Delivery': 'Shipt Delivery',
    'Consumer Cellular Cell Phone Activations':
        'Consumer Cellular Cell Phone Activations',
    'Fresh Grocery': 'Fresh Grocery',
    'AT&T Cell Phone Activations': 'AT&T Cell Phone Activations',
    'Off duty police or 3rd party security':
        'Off duty police or 3rd party security',
    'Prepaid Cell Phone Activations': 'Prepaid Cell Phone Activations',
    'Store Pickup': 'Store Pickup',
    'Mobile Operations': 'Mobile Operations',
    'Drive Up Returns': 'Drive Up Returns',
    'Prior Day': 'Prior Day',
    'Week to Day': 'Week to Day',
    'Prior Week': 'Prior Week',
    'Month to Day': 'Month to Day',
    'Year to Day': 'Year to Day',
    'Go back to the operations screen': 'Go back to the operations screen',
    sunday: 'sunday',
    monday: 'monday',
    tuesday: 'tuesday',
    wednesday: 'wednesday',
    thursday: 'thursday',
    friday: 'friday',
    saturday: 'saturday',
    ytd: 'ytd',
    Closed: 'Closed',
    Pfresh: 'Pfresh',
    'General Merch': 'General Merch',
    'Starbucks Cafe': 'Starbucks Cafe',
    'CVS pharmacy': 'CVS pharmacy',
    'Snack Bar - Pizza': 'Snack Bar - Pizza',
    insights: {
        title: 'insights.title',
        tabs: {
            yesterday: 'insights.tabs.yesterday',
            weekly: 'insights.tabs.weekly',
        },
        details: {
            title: 'insights.details.title',
            yesterday: 'insights.details.yesterday',
            week: 'insights.details.week',
            whatChanged: 'insights.details.whatChanged',
            whyItMatters: 'insights.details.whyItMatters',
            whereItsHappening: 'insights.details.whereItsHappening',
            recommendedNextMove: 'insights.details.recommendedNextMove',
            tableArea: 'insights.details.tableArea',
            tableValue: 'insights.details.tableValue',
            tableCompStore: 'insights.details.tableCompStore',
            tableCompDistrict: 'insights.details.tableCompDistrict',
            tableStatus: 'insights.details.tableStatus',
            statusStrong: 'insights.details.statusStrong',
            statusWeak: 'insights.details.statusWeak',
        },
        sectionNoData: 'insights.sectionNoData',
        locationNotEnrolled: 'insights.locationNotEnrolled',
        yesterdayAtAGlance: 'insights.yesterdayAtAGlance',
        viewInsightDetails: 'insights.viewInsightDetails',
        topTrendsFromLastWeek: 'insights.topTrendsFromLastWeek',
        storePerformance: {
            title: 'insights.storePerformance.title',
            pyramid: 'insights.storePerformance.pyramid',
            department: 'insights.storePerformance.department',
        },
        category: {
            performance: 'insights.category.performance',
            digital: 'insights.category.digital',
            district: 'insights.category.district',
        },
        checkBackLater: 'insights.checkBackLater',
        errorHeading: 'insights.errorHeading',
        storeInsightsError: {
            heading: 'insights.storeInsightsError.heading',
            message: 'insights.storeInsightsError.message',
            button: 'insights.storeInsightsError.button',
        },
        summaryDetails: 'insights.summaryDetails',
        summaryForYesterday: 'insights.summaryForYesterday',
        summaryForWeek: 'insights.summaryForWeek',
        noDataTitleYesterday: 'insights.noDataTitleYesterday',
        noDataTitleWeekly: 'insights.noDataTitleWeekly',
        categoryPerformance: {
            heading: 'insights.categoryPerformance.heading',
            strongVsDistrict: 'insights.categoryPerformance.strongVsDistrict',
            weakVsDistrict: 'insights.categoryPerformance.weakVsDistrict',
        },
        storeDistrictSnapshot: {
            header: 'insights.storeDistrictSnapshot.header',
            metric: 'insights.storeDistrictSnapshot.metric',
            district: 'insights.storeDistrictSnapshot.district',
            takeaway: 'insights.storeDistrictSnapshot.takeaway',
        },
        funFacts: {
            header: 'insights.funFacts.header',
        },
        audioPlayer: {
            listenToBriefing: 'insights.audioPlayer.listenToBriefing',
            aiAudioRecap: 'insights.audioPlayer.aiAudioRecap',
            viewTranscript: 'insights.audioPlayer.viewTranscript',
            transcript: 'insights.audioPlayer.transcript',
            audioLoadError: 'insights.audioPlayer.audioLoadError',
            audioUnavailable: 'insights.audioPlayer.audioUnavailable',
            transcriptUnavailable: 'insights.audioPlayer.transcriptUnavailable',
            fastForward: 'insights.audioPlayer.fastForward',
            rewind: 'insights.audioPlayer.rewind',
            fifteenSeconds: 'insights.audioPlayer.fifteenSeconds',
        },
    },
    powerBI: {
        popupError: 'powerBI.popupError',
        title: 'powerBI.title',
    },
}
